/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {registerEmail} from '../api'

export const useMutationRegisterEmail = createReactQueryMutationHook('registerEmail', registerEmail)
